import {AlertService} from '../../shared/services/alert.service';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Question } from '../../shared/models/question';
import { QuestionSet } from '../../shared/models/question-set';
import { AssessmentService } from '../../shared/services/assessment.service';
import { Assessment } from '../../shared/models/assessment';
import { Scale } from '../../shared/models/scale';
import { Router, ActivatedRoute } from '@angular/router';
import { QuestionType } from "../../shared/models/question-type";
import { QuestionFactoryService } from"../../shared/services/question-factory.service";
import { QuestionSetLabel } from 'app/shared/models/question-set-label';

@Component({
  selector: 'app-question-new',
  templateUrl: './question-new.component.html',
  styleUrls: ['./question-new.component.css']
})
export class QuestionNewComponent implements OnInit {

  private _question:Question;
  private _currentType:QuestionType;
  private questionSet:QuestionSet;
  private assessment:Assessment;
  private readonly SAVE_TIME = 1500;
  private readonly ERROR_MESSAGE_TIME = 3000;
  public isSaving:boolean;

  constructor(
    private assessmentService:AssessmentService
    ,private questionFactory:QuestionFactoryService
    ,private alertService: AlertService
    ,private location:Location
    ,private router: Router
    ,private route: ActivatedRoute
  ) { 
    // make the default to be multiple choice.
    this._currentType = QuestionType.MultipleChoice;
    this._question = this.getNewQuestion();
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      let assessmentUid = params['uid'];
      let setId = params['setId'];
      this.assessmentService.getAssessment(assessmentUid)
        .then((assessment:Assessment) => {
          this.assessment = assessment;
          this.questionSet = assessment.question_sets.find((s) => s.id == setId);
          if (!this.questionSet) {
            // TODO: stephen should we navigate back?? or do some kind of 404?
            this.router.navigate(["not-found"]);
          }
          this.setScaleIfSingle(this.question, this.assessment);
        })
        .catch((error) => {
          console.error(error);
          this.router.navigate(["not-found"]);
        })
    });
  }

  private setScaleIfSingle(question:Question, assessment:Assessment) {
    if (assessment && assessment.scales && assessment.scales.length == 1) {
      question.assessment_scale = this.assessment.scales[0];
    }
  }

  public updateType(event:Event) {
    let select = event.target as HTMLInputElement;
    this._currentType = +select                 .value;
    let newQuestion = this.getNewQuestion();
    newQuestion.prompt = this.question.prompt;
    newQuestion.is_reversed = this.question.is_reversed;
    this._question = newQuestion;
  }

  public get DisplayTypes() {
    let types = [
      {value: QuestionType.MultipleChoice, name: "Multiple Choice", isSelected: false}
      ,{value: QuestionType.Checklist, name: QuestionType[QuestionType.Checklist], isSelected: false}
      ,{value: QuestionType.Textbox, name: QuestionType[QuestionType.Textbox], isSelected: false}
      ,{value: QuestionType.SingleChoice, name: "Single Choice", isSelected: false}
    ]
    types.forEach(t => t.isSelected = t.value == this._currentType);
    return types;
  }

  private getNewQuestion() {
    let question = this.questionFactory.createQuestionForType(this._currentType);
    question.id = this.assessmentService.newId();
    this.setScaleIfSingle(question, this.assessment);
    return question;
  }

  get scales() : Scale[] {
    if (this.assessment) {
      return this.assessment.scales;
    }
    return null;
  }

  get question() : Question {
    return this._question;
  }

  get labels() : QuestionSetLabel[] {
    return (this.questionSet ? this.questionSet.labels : []);
  }

  public isMultipleChoiceQuestion() : boolean {
    return this._currentType == QuestionType.MultipleChoice;
  }

  private saveQuestion(question) {
    this.questionSet.addQuestion(question);
    this.isSaving = true;
		return this.assessmentService.saveAssessment(this.assessment).then((assessment) => {
      this.alertService.success("Question saved", this.SAVE_TIME);
      this.isSaving = false;
      return question;
    }).catch((error) => {
      this.isSaving = false;
      this.alertService.error("An error occurred in saving. Please try again or contact support.", this.ERROR_MESSAGE_TIME);
			console.error(error);
		});
  }

  save() {
    this.saveQuestion(this.question).then((question) => {
      setTimeout(() => {
        this.router.navigate(["../", this.question.id, "edit"], {relativeTo: this.route, replaceUrl:true});
			}, this.SAVE_TIME);
    });
	}
	
	saveAndCreateNew() {
    this.saveQuestion(this.question).then((question) => {
      this._question = this.getNewQuestion();
    });
	}
}



// WEBPACK FOOTER //
// ./src/app/admin/question-new/question-new.component.ts